import { cva } from "class-variance-authority";

const stylesText = cva("", {
  variants: {
    mode: {
      light: "text-light-label",
      dark: "text-dark-label"
    }
  }
});

export { stylesText };
